import PropTypes from "prop-types";
import useResponsiveWithHydrationFix from "@hooks/useResponsiveWithHydrationFix";
import { ALButtonV2 } from "@components/ALComponents";
import PackagingCard from "@components/sideCart/giftPackagingPopup/choosePackaging/PackagingCard";

function ChoosePackaging({
  onContinueClick,
  selectedPackaging,
  setSelectedPackaging,
  giftPackagingData,
  products,
  isLoading,
}) {
  const isMobile = useResponsiveWithHydrationFix(true, false);
  return (
    <div className="flex flex-col h-full">
      <p className="typo-h2-bold">Choose Gift Packaging</p>
      <div className="flex flex-col desktop:flex-row mb-[35px] desktop:gap-[20px]">
        {giftPackagingData.map((gift) => (
          <PackagingCard
            key={gift.handle}
            gift={gift}
            productData={products.find((product) => product.handle === gift.handle)}
            selectedPackaging={selectedPackaging}
            setSelectedPackaging={setSelectedPackaging}
            isLoading={isLoading}
          />
        ))}
      </div>
      <ALButtonV2
        fullWidth={isMobile}
        size="large"
        onClick={onContinueClick}
        className="mt-auto desktop:w-[375px] desktop:self-end desktop:mt-[15px]"
        disabled={!selectedPackaging}
      >
        Continue to Gift Note
      </ALButtonV2>
    </div>
  );
}

ChoosePackaging.propTypes = {
  onContinueClick: PropTypes.func.isRequired,
  selectedPackaging: PropTypes.objectOf(
    PropTypes.shape({
      handle: PropTypes.string.isRequired,
    })
  ).isRequired,
  setSelectedPackaging: PropTypes.func.isRequired,
  giftPackagingData: PropTypes.arrayOf(
    PropTypes.shape({
      handle: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      line1: PropTypes.string.isRequired,
      line2: PropTypes.string.isRequired,
    })
  ).isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      handle: PropTypes.string.isRequired,
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ChoosePackaging;
